import KunLoading119 from './src/index'

KunLoading119.install = function (Vue) {
	Vue.component(KunLoading119.name, KunLoading119);
}

export default KunLoading119;
